import { Container, Boxes, Package, PackageOpen, Frame, Truck, Layers, Forklift, Globe2, Route } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { TruckCameo } from "@/components/TruckCameo";
import { services } from "@/data/content";
import { useSiteContent } from "@/i18n/SiteContentContext";

const icons = [Truck, Container, Boxes, PackageOpen, Frame, Package, Layers, Forklift, Globe2, Route];

export const Services = () => {
  const { get } = useSiteContent();
  const serviceList = get("services", services);
  return (
  <section id="services" data-testid="services-section" className="honeycomb-bg-strong relative overflow-hidden bg-gradient-to-b from-ice/60 via-mist to-white py-28 md:py-40">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading
        number="02"
        eyebrow="What We Move"
        title={<>Ten ways we carry <span className="text-royal/40">your world.</span></>}
        description="From a single pallet to an 80-ton convoy — every load gets the same premium treatment, across all six GCC nations."
      />

      <div className="mb-14 flex justify-center">
        <TruckCameo from="right" />
      </div>

      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {serviceList.map((s, i) => {
          const Icon = icons[i % icons.length];
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`service-card-${i}`}
                className="glass-card hex-card group relative h-full overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:border-gold/40 hover:shadow-2xl hover:shadow-gold/15"
              >
                <div className="relative h-36 overflow-hidden">
                  <img src={s.image} alt={s.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy/40 via-transparent to-transparent" />
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-4">
                    <div className="grid h-12 w-12 shrink-0 place-items-center hex-clip bg-navy transition-colors duration-300 group-hover:bg-gold">
                      <Icon className="h-5 w-5 text-sky transition-colors duration-300 group-hover:text-navy" />
                    </div>
                    <div>
                      <p className="font-jakarta text-xs font-bold tracking-[0.2em] text-royal/40">{String(i + 1).padStart(2, "0")}</p>
                      <h3 className="font-jakarta text-lg font-bold leading-snug text-navy md:text-xl">{s.title}</h3>
                    </div>
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-royal/70 md:text-base">{s.text}</p>
                  <span className="mt-5 block h-1 w-10 rounded-full bg-royal/15 transition-all duration-300 group-hover:w-20 group-hover:bg-gold" />
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
  );
};